import React from "react";
import { motion } from "framer-motion";
import { Phone, ArrowUpRight } from "lucide-react";
import { BRAND } from "@/data";

export default function QuoteBand() {
  return (
    <section
      className="relative z-10 bg-[#7AB648] py-16 md:py-24"
      data-testid="quote-band"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <h2 className="font-display uppercase text-5xl md:text-7xl text-[#14171A] leading-[0.9]">
            Need a Free Quote?
          </h2>
          <p className="mt-4 font-body text-base md:text-lg text-[#14171A]/80 max-w-xl">
            Call {BRAND.phone} or email us today. We cover {BRAND.area}.
          </p>
        </motion.div>

        <div className="flex flex-col sm:flex-row gap-4 shrink-0">
          <a
            href={BRAND.phoneHref}
            className="inline-flex items-center justify-center gap-2 rounded-sm bg-[#14171A] px-8 py-4 font-head font-bold uppercase tracking-wide text-white transition-colors hover:bg-[#1E2227] active:scale-95"
            data-testid="quote-band-call"
          >
            <Phone size={18} />
            Call Now
          </a>
          <a
            href="#bookings"
            className="group inline-flex items-center justify-center gap-2 rounded-sm border-2 border-[#14171A] px-8 py-4 font-head font-bold uppercase tracking-wide text-[#14171A] transition-colors hover:bg-[#14171A] hover:text-white active:scale-95"
            data-testid="quote-band-book"
          >
            Book Online
            <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </a>
        </div>
      </div>
    </section>
  );
}
